export const CLIENT_JOURNEY_STEPS = [
  { key: 'capabilities', label: 'Capabilities', hint: 'Choose focus areas' },
  { key: 'assessment', label: 'Assessment', hint: 'Rate current & future state' },
  { key: 'review', label: 'Expert review', hint: 'SME collaboration' },
  { key: 'report', label: 'Your report', hint: 'Insights & recommendations' },
] as const;

/** Maps backend project state to the active journey step (0–3). */
export function getClientJourneyIndex(state: number): number {
  if (state <= 1) return 0;
  if (state === 2) return 1;
  if (state === 3) return 2;
  if (state <= 5) return 2;
  return 3;
}

/**
 * UI journey index — advances to Assessment once capabilities are selected even when
 * backend project state is still 1 (selection done, assessment not started).
 */
export function resolveClientJourneyIndex(state: number, capabilityCount: number): number {
  const fromState = getClientJourneyIndex(state);
  if (capabilityCount > 0 && fromState === 0 && state < 3) {
    return 1;
  }
  return fromState;
}

export function getClientPhaseLabel(state: number): string {
  if (state <= 0) return 'Getting started';
  if (state === 1) return 'Selecting capabilities';
  if (state === 2) return 'Assessment in progress';
  if (state === 3) return 'Submitted for review';
  if (state <= 5) return 'Expert review';
  return 'Report ready';
}

export function firstName(fullName?: string): string {
  const trimmed = (fullName || '').trim();
  if (!trimmed) return 'there';
  return trimmed.split(/\s+/)[0] || 'there';
}
